
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class SplitContent extends Vue {
  @Prop()
  public splashImgName!: string;
  @Prop({ default: false })
  public isSplit!: boolean;
}
